var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2143 0.857178H2.78571C1.24777 0.857178 0 2.10495 0 3.64289V24.0715C0 25.6094 1.24777 26.8572 2.78571 26.8572H23.2143C24.7522 26.8572 26 25.6094 26 24.0715V3.64289C26 2.10495 24.7522 0.857178 23.2143 0.857178ZM5.33929 16.1786C4.95625 16.1786 4.64286 15.8652 4.64286 15.4822V12.2322C4.64286 11.8491 4.95625 11.5357 5.33929 11.5357H20.6607C21.0437 11.5357 21.3571 11.8491 21.3571 12.2322V15.4822C21.3571 15.8652 21.0437 16.1786 20.6607 16.1786H5.33929Z",
    fill: "#5F5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTicket);
export default __webpack_public_path__ + "static/media/delete-ticket.3f33e783c139e65fbedc5082837af86f.svg";
export { ForwardRef as ReactComponent };